(ns iris.views
  {:shadow.css/include ["iris/styles/global.css"]}
  (:require
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [iris.routes :as routes]
   [iris.subs :as subs]
  ;;  [iris.screens.views :as screens-views]
  ;;  [iris.censors.views :as censors-views]
  ;;  [iris.posts.views :as posts-views]
  ;;  [iris.twbot.views :as twbot-views]
  ;;  [iris.analytics.views :as analytics-views]
  ;;  [iris.search.views :as search-views]
   [iris.login.views :as login-views]
   [iris.login.events :as login-events]
   [iris.error.views :as error-views]
   [iris.globals :as globals]
   [iris.firebase :as fb]
   [cljs.core.async :refer [go]]
   [cljs.core.async.interop :refer-macros [<p!]]

   [iris.localstorage :as localstorage]

   [iris.lazyload :refer (lazy-component)]))



;; (defmethod routes/panels :screens-panel [] [screens-views/screens-panel])

;; (defmethod routes/panels :screens-create-new-panel [] [screens-views/screens-create-new-panel])

;; (defmethod routes/panels :screens-edit-panel [] [screens-views/screens-edit-panel])


;; (defmethod routes/panels :censors-create-new-panel [] [censors-views/censors-create-new-panel])

;; (defmethod routes/panels :censors-panel [] [censors-views/censors-panel])

;; (defmethod routes/panels :censors-edit-panel [] [censors-views/censors-edit-panel])


;; (defmethod routes/panels :user-panel [] [posts-views/user-panel])

;; (defmethod routes/panels :thread-panel [] [posts-views/thread-panel])

;; (defmethod routes/panels :posts-header-panel [] [posts-views/posts-header-panel])

;; (defmethod routes/panels :hashtag-panel [] [posts-views/hashtag-panel])

;; (defmethod routes/panels :posts-ip-panel [] [posts-views/posts-ip-panel])
;; (defmethod routes/panels :posts-eid-panel [] [posts-views/posts-eid-panel])
;; (defmethod routes/panels :posts-cc-panel [] [posts-views/posts-cc-panel])
;; (defmethod routes/panels :posts-panel [] [posts-views/posts-panel])

;; (defmethod routes/panels :twbot-panel [] [twbot-views/twbot-panel])

;; (defmethod routes/panels :analytics-panel [] [analytics-views/analytics-panel])

;; (defmethod routes/panels :search-panel [] [search-views/search-panel])
;; (defmethod routes/panels :search-panel [] [posts-views/search-panel])

;; KEEPING LOGIN BECAUSE WE DIDN'T TURN IT INTO LAZY LOADED MODULE:
(defmethod routes/panels :login-panel [] [login-views/login-panel])

(defmethod routes/panels :error-panel [] [error-views/error-panel])

(def homepage-panel (lazy-component iris.homepage.views/homepage-panel))

;; (def search (lazy-component iris.search.views/search-panel))
(def search (lazy-component iris.posts.views/search-panel))

(def screens (lazy-component iris.screens.views/screens-panel))
(def screens-create (lazy-component iris.screens.views/screens-create-new-panel))
(def screens-edit (lazy-component iris.screens.views/screens-edit-panel))

(def censors (lazy-component iris.censors.views/censors-panel))
(def censors-create (lazy-component iris.censors.views/censors-create-new-panel))
(def censors-edit (lazy-component iris.censors.views/censors-edit-panel))

(def user-panel (lazy-component iris.posts.views/user-panel))
(def thread-panel (lazy-component iris.posts.views/thread-panel))
(def posts-header-panel (lazy-component iris.posts.views/posts-header-panel))
(def hashtag-panel (lazy-component iris.posts.views/hashtag-panel))
(def posts-ip-panel (lazy-component iris.posts.views/posts-ip-panel))
(def posts-eid-panel (lazy-component iris.posts.views/posts-eid-panel))
(def posts-cc-panel (lazy-component iris.posts.views/posts-cc-panel))
(def posts-panel (lazy-component iris.posts.views/posts-panel))

(def analytics-panel (lazy-component iris.analytics.views/analytics-panel))
(def analytics-page-views-panel (lazy-component iris.analytics.views/analytics-page-views-panel))

(def tags-panel (lazy-component iris.tags.views/tags-panel))
(def tags-pending-panel (lazy-component iris.tags.views/tags-pending-panel))
(def tags-approved-panel (lazy-component iris.tags.views/tags-approved-panel))
(def tags-removed-panel (lazy-component iris.tags.views/tags-removed-panel))
(def tags-blocked-panel (lazy-component iris.tags.views/tags-blocked-panel))

(def sessions-panel (lazy-component iris.sessions.views/sessions-panel))

(def logs-panel (lazy-component iris.logs.views/logs-panel))
(def logs-header-panel (lazy-component iris.logs.views/logs-header-panel))
(def logs-post-panel (lazy-component iris.logs.views/logs-post-panel))
(def logs-thread-panel (lazy-component iris.logs.views/logs-thread-panel))
(def logs-ip-panel (lazy-component iris.logs.views/logs-ip-panel))
(def logs-eid-panel (lazy-component iris.logs.views/logs-eid-panel))
(def logs-user-panel (lazy-component iris.logs.views/logs-user-panel))
(def logs-header-create-panel (lazy-component iris.logs.views/logs-header-create-panel))
(def logs-chosen-header-create-panel (lazy-component iris.logs.views/logs-chosen-header-create-panel))
(def logs-chosen-header-edit-panel (lazy-component iris.logs.views/logs-chosen-header-edit-panel))
(def logs-search-panel (lazy-component iris.logs.views/logs-search-panel))
(def dev-panel (lazy-component iris.dev.views/dev-panel))

(def latest-panel (lazy-component iris.posts.views/latest-panel))


(defmethod routes/panels :homepage-panel [] [:> homepage-panel])

(defmethod routes/panels :search-panel [] [:> search])

(defmethod routes/panels :screens-panel [] [:> screens])
(defmethod routes/panels :screens-create-new-panel [] [:> screens-create])
(defmethod routes/panels :screens-edit-panel [] [:> screens-edit])

(defmethod routes/panels :censors-panel [] [:> censors])
(defmethod routes/panels :censors-create-new-panel [] [:> censors-create])
(defmethod routes/panels :censors-edit-panel [] [:> censors-edit])

(defmethod routes/panels :user-panel [] [:> user-panel])
(defmethod routes/panels :thread-panel [] [:> thread-panel])
(defmethod routes/panels :posts-header-panel [] [:> posts-header-panel])
(defmethod routes/panels :hashtag-panel [] [:> hashtag-panel])
(defmethod routes/panels :posts-ip-panel [] [:> posts-ip-panel])
(defmethod routes/panels :posts-eid-panel [] [:> posts-eid-panel])
(defmethod routes/panels :posts-cc-panel [] [:> posts-cc-panel])
(defmethod routes/panels :posts-panel [] [:> posts-panel])

(defmethod routes/panels :analytics-panel [] [:> analytics-panel])
(defmethod routes/panels :analytics-page-views-panel [] [:> analytics-page-views-panel])

(defmethod routes/panels :tags-panel [] [:> tags-panel])
(defmethod routes/panels :tags-pending-panel [] [:> tags-pending-panel])
(defmethod routes/panels :tags-approved-panel [] [:> tags-approved-panel])
(defmethod routes/panels :tags-removed-panel [] [:> tags-removed-panel])
(defmethod routes/panels :tags-blocked-panel [] [:> tags-blocked-panel])

(defmethod routes/panels :sessions-panel [] [:> sessions-panel])

(defmethod routes/panels :logs-panel [] [:> logs-panel])
(defmethod routes/panels :logs-header-panel [] [:> logs-header-panel])
(defmethod routes/panels :logs-post-panel [] [:> logs-post-panel])
(defmethod routes/panels :logs-thread-panel [] [:> logs-thread-panel])
(defmethod routes/panels :logs-ip-panel [] [:> logs-ip-panel])
(defmethod routes/panels :logs-eid-panel [] [:> logs-eid-panel])
(defmethod routes/panels :logs-user-panel [] [:> logs-user-panel])
(defmethod routes/panels :logs-header-create-panel [] [:> logs-header-create-panel])
(defmethod routes/panels :logs-chosen-header-create-panel [] [:> logs-chosen-header-create-panel])
(defmethod routes/panels :logs-chosen-header-edit-panel [] [:> logs-chosen-header-edit-panel])
(defmethod routes/panels :logs-search-panel [] [:> logs-search-panel])
(defmethod routes/panels :dev-panel [] [:> dev-panel])

(defmethod routes/panels :latest-panel [] [:> latest-panel])







;; TODO: should ws be set in app state after getting it from fb??
;; TODO: since ws is synced on fb-sign-in it makes no sense to call fb for info on default ws here once again
;; (defn default-ws-redirect [active-panel panel param route]
;;   (when (= active-panel panel)
;;     (let [route-params (re-frame/subscribe [::subs/route-params])
;;           ruid (param @route-params)]
;;       (when (nil? (re-find #"^.+\.[A-Z]{3}$" ruid))
;;         (go
;;           (let [_ (<p! (fb/auth-promise))
;;                 ws (or (<p! (fb/<p-get-defaults-ws)) "TLO")]
;;             (re-frame/dispatch [::events/route-to (str "/" route ruid "." ws)])))
;;         (throw "Default WS redirect...")))))

;; (defn default-ws-redirect [ws active-panel panel param route]
;;   (when (= active-panel panel)
;;     (let [route-params (re-frame/subscribe [::subs/route-params])
;;           ruid (param @route-params)]
;;       (when (nil? (re-find #"^.+\.[A-Z]{3}$" ruid))
;;         (re-frame/dispatch [::events/route-to-replace (str "/" route ruid "." ws)])
;;         (throw "Default WS redirect...")))))

;; 06/28/2025
(defn default-ws-redirect [ws active-panel panel param route]
  (when (= active-panel panel)
    (let [route-params (re-frame/subscribe [::subs/route-params])
          ruid (param @route-params)]
      (when (and ruid (nil? (re-find #"^.+\.[A-Z]{3}$" ruid)))
        (re-frame/dispatch [::events/route-to-replace (str "/" route ruid "." ws)])
        true)))) ;; return true if redirected



;; (defn main-panel []
;;   (let [active-panel (re-frame/subscribe [::subs/active-panel])]
;;     (cond (= @active-panel :login-panel)
;;           (routes/panels :login-panel)
;;           (true? (login-events/logged-in?))
;;           (try
;;             (default-ws-redirect @active-panel :posts-header-panel :header "")
;;             (default-ws-redirect @active-panel :hashtag-panel :tag "h/")
;;             (routes/panels @active-panel)
;;             (catch :default e
;;               (println e)))
;;           :else
;;           (do
;;             (reset! globals/login_redirect (.. js/window -location -pathname))
;;             (re-frame/dispatch [::events/navigate :login])))))

;; (defn main-panel []
;;   (let [active-panel (re-frame/subscribe [::subs/active-panel])
;;         ws-sync (re-frame/subscribe [::subs/ws-sync])
;;         ws (re-frame/subscribe [::subs/ws])]
;;     (cond (= @active-panel :login-panel)
;;           (routes/panels :login-panel)
;;           (and (true? (login-events/logged-in?)) (true? @ws-sync))
;;           (try
;;             (default-ws-redirect @ws @active-panel :posts-header-panel :header "")
;;             (default-ws-redirect @ws @active-panel :hashtag-panel :tag "h/")
;;             (routes/panels @active-panel)
;;             (catch :default e
;;               (println e)))
;;           (and (true? (login-events/logged-in?)) (not @ws-sync))
;;           (println "Still syncing ws...")
;;           :else
;;           (do
;;             (reset! globals/login_redirect (.. js/window -location -pathname))
;;             (re-frame/dispatch [::events/navigate :login])))))

;; (defn main-panel []
;;   (let [active-panel (re-frame/subscribe [::subs/active-panel])
;;         ws-sync (re-frame/subscribe [::subs/ws-sync])
;;         ws (re-frame/subscribe [::subs/ws])]
;;     (cond (= @active-panel :login-panel)
;;           (routes/panels :login-panel)
;;           (and (true? (login-events/logged-in?)) (true? @ws-sync))
;;           (try
;;             (default-ws-redirect @ws @active-panel :posts-header-panel :header "")
;;             (default-ws-redirect @ws @active-panel :hashtag-panel :tag "h/")
;;             (routes/panels @active-panel)
;;             (catch :default e
;;               (println e)))
;;           (and (true? (login-events/logged-in?)) (not @ws-sync))
;;           (println "Still syncing ws...")
;;           :else
;;           (let [l (.. js/window -location)
;;                 p (str l.pathname l.search l.hash)]
;;             (reset! globals/login_redirect p)
;;             (re-frame/dispatch [::events/navigate :login])))))

;; 06/28/2025
(defn main-panel []
  (let [active-panel (re-frame/subscribe [::subs/active-panel])
        ws-sync (re-frame/subscribe [::subs/ws-sync])
        ws (re-frame/subscribe [::subs/ws])]
    (cond
      (= @active-panel :login-panel)
      (routes/panels :login-panel)

      (and (login-events/logged-in?) @ws-sync)
      (let [redirected?
            (or (default-ws-redirect @ws @active-panel :posts-header-panel :header "")
                (default-ws-redirect @ws @active-panel :hashtag-panel :tag "h/"))]
        (if redirected?
          ;; skip rendering if redirect dispatched
          (do (println "Redirected, skipping panel render."))
          ;; no redirect, go ahead and render
          (routes/panels @active-panel)))

      (and (login-events/logged-in?) (not @ws-sync))
      (println "Still syncing ws...")

      :else
      (let [l (.. js/window -location)
            p (str l.pathname l.search l.hash)]
        (reset! globals/login_redirect p)
        (re-frame/dispatch [::events/navigate :login])))))
